export const getPath = () => {
  return process.env.NODE_ENV !== 'production'
    ? 'http://localhost:8080'
    : './admin/';
};

export const sortData = (pages) => {
  if (!!pages?.length) {
    return pages.sort((a, b) => {
      var da = new Date(a.content?.date || 0).getTime();
      var db = new Date(b.content?.date || 0).getTime();

      return db - da;
    });
  }

  return pages;
};

export const shuffleArray = (array) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
